import React from "react";
import { Link } from "react-router-dom";
import { HERO_IMAGE, HERO_VIDEO } from "../data/assets";
import { useI18n } from "../data/i18n";

const RestaurantVideo = () => {
  const { lang } = useI18n();
  const isBg = lang === "bg";

  return (
    <div className="min-h-screen bg-[#0a0a0a] pt-32 pb-24 text-[#f5f0e6]">
      <article className="max-w-6xl mx-auto px-5 md:px-8">
        <header className="max-w-3xl mx-auto text-center mb-10">
          <p className="section-label text-[#e4c590] mb-4">CASA BALA VIDEO</p>
          <h1 className="display text-4xl md:text-6xl font-light leading-tight mb-5">
            {isBg ? "Преживейте атмосферата на CASA BALA" : "Experience the Atmosphere of CASA BALA"}
          </h1>
          <p className="text-[#cfc7b8] text-base md:text-lg leading-relaxed">
            {isBg
              ? "Погледнете отблизо атмосферата, кухнята и средиземноморското изживяване в CASA BALA, София."
              : "Take a closer look at the atmosphere, cuisine and Mediterranean dining experience at CASA BALA in Sofia."}
          </p>
        </header>

        <div className="max-w-5xl mx-auto bg-black border border-[#e4c590]/30 shadow-2xl">
          <video
            controls
            playsInline
            preload="metadata"
            poster={HERO_IMAGE}
            className="block w-full aspect-video object-cover"
          >
            <source src={HERO_VIDEO} type="video/mp4" />
            {isBg ? "Браузърът ви не поддържа видео." : "Your browser does not support video playback."}
          </video>
        </div>

        <div className="max-w-3xl mx-auto text-center mt-10">
          <h2 className="display text-3xl md:text-4xl mb-4">
            {isBg ? "Средиземноморски ресторант в София" : "Mediterranean Restaurant in Sofia"}
          </h2>
          <p className="text-[#cfc7b8] leading-relaxed mb-8">
            {isBg
              ? "Откритата кухня позволява на гостите да наблюдават нашите готвачи, докато приготвят храната. Посетете ни за обяд, вечеря или специално събитие."
              : "Our open kitchen lets guests watch the chefs prepare each dish. Visit us for lunch, dinner or a special event."}
          </p>
          <Link to="/reservation" className="cb-btn cb-btn-gold inline-block">
            <span className="cb-btn-text cb-btn-text-1">{isBg ? "Резервирайте маса" : "Book a Table"}</span>
            <span className="cb-btn-text cb-btn-text-2" aria-hidden="true">{isBg ? "Резервирайте маса" : "Book a Table"}</span>
          </Link>
        </div>
      </article>
    </div>
  );
};

export default RestaurantVideo;
